import React, { useEffect, useState } from 'react'
import Bredcrum from '../../common/Bredcrum'
import CourseDetailOverview from './CourseDetailOverview'

// images
import courseImg1 from '../../../assets/images/courses/course-1.jpg'
import courseImg2 from '../../../assets/images/courses/course-2.jpg'
import courseImg3 from '../../../assets/images/courses/course-3.jpg'
import courseImg4 from '../../../assets/images/courses/course-4.jpg'
import { useParams } from 'react-router-dom'

import team1 from "../../../assets/images/team/team-1.jpg"
import team2 from "../../../assets/images/team/team-2.jpg"
import team3 from "../../../assets/images/team/team-3.jpg"
import InstructorCard from '../../Reusable/InstructorCard'
import CourseVideo from './CourseVideo'

import carImg from '../../../assets/images/car-1.png'
import shape76 from '../../../assets/images/shapes/shape-89.png'
import { courses_data } from './course_data'
import { axiosInstance } from '../config'

const CourseDetails = () => {

    const [courseData, setCourseData] = useState([])
    const [loading , setLoading] = useState(false);
    const { course_slug } = useParams()

    useEffect(() => {
        getCourseInfo();
    }, [course_slug])

    function getCourseInfo() {
        setLoading(true)
        axiosInstance.get(`get-cources/${course_slug}`)
            .then(res => {
                setCourseData(res?.data?.cource);
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setLoading(false)
            })
    }

    return (
        <>
            <Bredcrum
                heading={courseData.title}
                path={[
                    { name: 'Courses', path: 'courses' },
                    { name: courseData.title, path: `courses/${courseData.id}` }
                ]}
            />
            {/* course overview */}
            <CourseDetailOverview courseData={courseData} />

            {/* video section */}
            {/* <CourseVideo bgImage={courseData?.imageUrl} /> */}

            <section className="advanced-section">
                <div className="auto-container">
                    <div className="row clearfix">
                        <div className="col-lg-4 col-md-6 col-sm-12 title-column">
                            <div className="title-inner">
                                <div className="sec-title">
                                    <h2>
                                        The advanced level course <br />
                                        is designed for our leaners
                                    </h2>
                                </div>
                                {/* <div className="download-box">
                                    <div className="icon">
                                        <i className="bi bi-download text-white" />
                                    </div>
                                    <h4>
                                        <a href="#">Download Course Content</a>
                                    </h4>
                                    <h5>pdf.4mb</h5>
                                </div> */}
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 image-column">
                            <div className="image-box">
                                <div
                                    className="shape"
                                    style={{ backgroundImage: `url(${shape76})` }}
                                />
                                <figure className="image">
                                    <img src={carImg} alt="Car Image" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12 text-column">
                            <div className="text-inner">
                                <p>
                                    Rejects dislikes or avoid pleasure itself because it pleasure but
                                    those who do not know how too know how to pursue pleasure.
                                </p>
                                <ul className="list-style-one clearfix">
                                    <li>Responsibilities as a Driver</li>
                                    <li>Vehicle Controls</li>
                                    <li>Traffics Signs &amp; Control Devices</li>
                                    <li>Rules of the Road</li>
                                    <li>Encountering other Road Users</li>
                                    <li>Driving in Dangerous Condition</li>
                                    <li>Incase of Accident</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Meet our expert trainers */}
            {
                courseData?.instructors?.length > 0 && (
                    <section className="team-section course-details">
                        <div className="auto-container">
                            <div className="sec-title light centred">
                                <h2>Meet our expert trainers</h2>
                            </div>
                            <div className="row clearfix">
                                {
                                    courseData?.instructors?.map((instructor, index) => {
                                        return (
                                            <InstructorCard key={index} instructor={instructor} dark={true} />
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </section>
                )
            }
        </>
    )
}

export default CourseDetails